import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IFlatTourBooking } from '../../types/flatTourBooking';

interface IFlatTourBookingState {
  flatTourBooking: IFlatTourBooking | null;
}

const initialState: IFlatTourBookingState = {
  flatTourBooking: null,
};

export const flatTourBookingSlice = createSlice({
  name: 'flatTourBookingState',
  initialState,
  reducers: {
    setScheduleData: (state, action: PayloadAction<IFlatTourBooking>) => {
      state.flatTourBooking = action.payload;
    },
  },
});

export const {
  reducer: flatTourBookingReducer,
  actions: { setScheduleData },
} = flatTourBookingSlice;
